import type { Overlay } from '@shared/types'
import { TitleInspector } from './TitleInspector'
import { LabelInspector } from './LabelInspector'
import { EndCardInspector } from './EndCardInspector'
import { LogoInspector } from './LogoInspector'
import { FreeTextInspector } from './FreeTextInspector'

/** Overlay 選択時の種類別ディスパッチ（task spec §3-3）。 */
export function OverlayInspector({ overlay }: { overlay: Overlay }) {
  switch (overlay.kind) {
    case 'title':
      return <TitleInspector overlay={overlay} />
    case 'label':
      return <LabelInspector overlay={overlay} />
    case 'end':
      return <EndCardInspector overlay={overlay} />
    case 'logo':
      return <LogoInspector overlay={overlay} />
    case 'free':
      return <FreeTextInspector overlay={overlay} />
    default:
      return null
  }
}
